import _defineProperty from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import React from 'react';
import { Alert, Button, Card, Container, Col, Form, Row } from 'react-bootstrap';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import TextField from '@mui/material/TextField';
import { bindingsReady } from './bindings';
import styles from '../styles/file-uploader.less';
import logger from '../utils/logger';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var log = logger.createLogger('Sharer');
function logoURLValidation(url) {
  if (url === null || url === '') {
    return {};
  }
  var helperText = false;
  if (!url.startsWith('http://') && !url.startsWith('https://') && !url.startsWith('data:')) {
    helperText = 'URL must start with https://, http://, or data:';
  } else if (url.startsWith('http') && !url.match(/\.(png|gif|jpg|jpeg|svg|webp)$/i)) {
    helperText = 'HTTP URL must end with png/gif/jpg/jpeg/svg|webp';
  }
  return !helperText ? {} : {
    'error': true,
    'variant': 'outlined',
    helperText: helperText
  };
}
export function Sharer(_ref) {
  var visible = _ref.visible,
    setVisualizationBindings = _ref.setVisualizationBindings,
    visualizationBindings = _ref.visualizationBindings,
    visualization = _ref.visualization,
    user = _ref.user,
    files = _ref.files;
  function wrapper(body) {
    return /*#__PURE__*/_jsxs("div", {
      className: "".concat(styles['sharer']),
      children: [/*#__PURE__*/_jsx("h5", {
        children: "Share your results"
      }), /*#__PURE__*/_jsxs("p", {
        children: ["At any time, you can manage your uploads using the ", /*#__PURE__*/_jsx("a", {
          href: "/datasets",
          children: "visualization gallery"
        }), " and ", /*#__PURE__*/_jsx("a", {
          href: "/files",
          children: "file manager"
        })]
      }), /*#__PURE__*/_jsxs("p", {
        children: [/*#__PURE__*/_jsx("i", {
          children: "Note"
        }), ": When a new preview visualization loads, the old preview & link expires"]
      }), body]
    });
  }
  if (!visible) {
    return null;
  }
  var setVizPropByEventTargetValue = function setVizPropByEventTargetValue(propName) {
    return function (event) {
      log.debug({
        propName: propName,
        event: event
      }, 'Set viz prop (event trigger)');
      if (!event || !event.target) {
        log.warn({
          event: event
        }, 'setVizPropByEventTargetValue event without target');
        return;
      }
      var val = event.target.value; //may be nulled later?
      setVisualizationBindings(function (vizBindings) {
        return _objectSpread(_objectSpread({}, vizBindings), {}, _defineProperty({}, propName, val));
      });
    };
  };
  var _bindingsReady = bindingsReady({
      files: files,
      visualizationBindings: visualizationBindings
    }),
    isReady = _bindingsReady.isReady,
    message = _bindingsReady.message;
  if (!isReady || !visualization.dataset_id) {
    return wrapper(/*#__PURE__*/_jsx(Card, {
      className: "".concat(styles['sharer-fail-message']),
      children: /*#__PURE__*/_jsx(Card.Title, {
        children: !isReady ? 'Please finish configuring visualization first' : 'Visualization uploading...'
      })
    }));
  }
  var formGroupOpts = {
    as: Row
  };
  var labelColOpts = {
    column: true,
    sm: 2,
    className: "".concat(styles['sharer-form-label'])
  };
  var valColOpts = {
    sm: 10
  };
  var url = "".concat(window.location.protocol, "//").concat(window.location.host, "/graph/graph.html?dataset=").concat(visualization.dataset_id);
  return wrapper(/*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs(Card, {
      className: "".concat(styles['viz-form-card'], " ").concat(styles['visualization-config-screen']),
      children: [/*#__PURE__*/_jsxs(Card.Header, {
        children: ["Describe ", /*#__PURE__*/_jsx("i", {
          children: "optional"
        })]
      }), /*#__PURE__*/_jsxs(Card.Body, {
        children: [/*#__PURE__*/_jsx(TextField, {
          id: "datasetName",
          type: "text",
          label: "name",
          name: "name",
          defaultValue: visualizationBindings.name,
          onChange: setVizPropByEventTargetValue('name')
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(TextField, {
          id: "datasetDescription",
          type: "text",
          label: "description",
          name: "description",
          defaultValue: visualizationBindings.description,
          multiline: true,
          rows: 2,
          onChange: setVizPropByEventTargetValue('description')
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(TextField, _objectSpread({
          id: "logoURL",
          type: "text",
          label: "Logo URL",
          name: "logourl",
          defaultValue: visualizationBindings.logoUrl,
          multiline: true,
          rows: 2,
          onChange: setVizPropByEventTargetValue('logoUrl')
        }, logoURLValidation(visualizationBindings.logoUrl)))]
      })]
    }), /*#__PURE__*/_jsxs(Card, {
      className: "".concat(styles['viz-form-card'], " ").concat(styles['visualization-config-screen']),
      children: [/*#__PURE__*/_jsx(Card.Header, {
        children: "Share"
      }), /*#__PURE__*/_jsx(Card.Body, {
        children: /*#__PURE__*/_jsxs(Form, {
          children: [
          /*
          <Form.Group {...formGroupOpts}>
             <Form.Label {...labelColOpts}>Name</Form.Label>
             <Col {...valColOpts}>
                 <span>{visualizationBindings.name}</span>
             </Col>
          </Form.Group>
          <Form.Group {...formGroupOpts}>
             <Form.Label {...labelColOpts}>Description</Form.Label>
             <Col {...valColOpts}>
                 <span>{visualizationBindings.description}</span>
             </Col>
          </Form.Group>
          */
          null, /*#__PURE__*/_jsxs(Form.Group, _objectSpread(_objectSpread({}, formGroupOpts), {}, {
            children: [/*#__PURE__*/_jsx(Form.Label, _objectSpread(_objectSpread({}, labelColOpts), {}, {
              children: "Link"
            })), /*#__PURE__*/_jsxs(Col, _objectSpread(_objectSpread({}, valColOpts), {}, {
              children: [/*#__PURE__*/_jsx("a", {
                href: url,
                children: url
              }), /*#__PURE__*/_jsx("span", {
                children: "\xA0"
              }), /*#__PURE__*/_jsx(CopyToClipboard, {
                text: url,
                children: /*#__PURE__*/_jsxs("button", {
                  className: "".concat(styles['copy-to-clipboard'], " btn btn-primary"),
                  alt: 'Copy link to clipboard',
                  children: [/*#__PURE__*/_jsx("i", {
                    className: 'fa fa-clipboard'
                  }), " Copy"]
                })
              })]
            }))]
          }))]
        })
      })]
    })]
  }));
}